import React, { Fragment } from 'react'
import { Div, ToolTip, Input, Button, Form, P, Icon, A } from '@drifthq/tide-core'
import cx from 'classnames'
import { ReCaptcha } from 'react-recaptcha-google'

import * as passUtils from 'utils/password'
import EmailInput from 'components/EmailInput'
import Consent from 'components/Consent'
import PasswordInput from 'components/PasswordInput'
import { DynamicNotification } from 'components/DynamicNotification'
import { track } from 'utils/trackingUtils'

import GoogleAuth from 'layouts/SignupChoiceCard/GoogleAuth'
import MicrosoftAuth from 'layouts/SignupChoiceCard/MicrosoftAuth'

const trackVideoSignInNotification = () => {
  track('Onboarding Setup Sign-In Triggered', {
    context: 'verify email step',
    product: 'video',
  })
}

export const INVALID_DOMAINS = [
  '@gmail.',
  '@yahoo.',
  '@hotmail.',
  '@live.',
  '@aol.',
  '@outlook.',
  '@comcast.',
  '@inbox.',
  '@icloud.',
  '@mail.com',
]

const SignupCard = ({
  name,
  email,
  password,
  onNameChange,
  onEmailChange,
  onPasswordChange,
  onContinueClick,
  onFindMyTeamClick,
  onVideoSignInClick,
  disabledEmail,
  validEmail,
  isGdprConsentRequired,
  isGdprConsentGranted,
  setGdprConsentGranted,
  createOrgLoading,
  checkEmailIsSSOEnabledPending,
  splitLoading,
  hideError,
  createOrgError,
  verifyCallback,
  setVerifyCallback,
  setRecaptchaReference,
  onProcessingGoogleCode,
  onProcessingExternalGoogleCode,
  onProcessingMicrosoftCode,
  oauthError,
  domainFound,
  hidePopup,
  onCreateNewAccount,
  onVideoCreateNewAccount,
  search,
  hideRecaptcha,
  loginUrl,
}) => {
  const displayToolTip = INVALID_DOMAINS.some(domain => email.includes(domain))
  const showVideoSignInNotice = createOrgError && createOrgError.endsWith('has already been used')

  return (
    <Form className="video-signup-card" onSubmit={onContinueClick}>
      <Div className="video-signup-card-content">
        <Icon className="video-signup-drift-logo" name="drift-logo-round" />
        <h1 className="video-signup-header">Welcome to Drift Video</h1>
        <P className="video-signup-header-subcopy">The easiest way to record and share videos with clients, colleagues, customers and more &ndash; all 100% for free.</P>
        <Input
          value={name}
          onChange={onNameChange}
          className="video-signup-input"
          placeholder="Name"
          autoFocus
        />
        <ToolTip
          className="touchless-start-tooltip"
          open={displayToolTip}
          hover={displayToolTip}
          flow="right"
          render={() => 'We recommend using a work email in order to get the most out of Drift'}
        />
        <EmailInput
          placeholder="Work email"
          className={cx('video-signup-input', {
            'touchless-email-input-error':
              !hideError && !showVideoSignInNotice && (!!createOrgError || !validEmail),
            'touchless-email-input-disable': disabledEmail,
          })}
          onChange={onEmailChange}
          value={email}
          hideError={hideError || showVideoSignInNotice}
          createOrgError={createOrgError}
          valid={validEmail}
          unique={!createOrgError}
          disabled={disabledEmail}
          type={'text'}
          shouldAutofocus={false}
        />
        {showVideoSignInNotice && (
          <DynamicNotification
            type="videoSignIn"
            onClick={onVideoSignInClick}
            onCreate={onVideoCreateNewAccount}
            onTrack={trackVideoSignInNotification}
          />
        )}
        <PasswordInput
          value={password}
          onChange={onPasswordChange}
          label={null}
          experiment={true}
          passwordConfig={passUtils.getDefaultConfig()}
          passwordConfigFetched={true}
          passwordUpdateStatus={null}
        />
        {!hideRecaptcha && (
          <ReCaptcha
            className="touchless-start-recaptcha"
            size="normal"
            theme="light"
            render="explicit"
            sitekey="6Lf5Zp4UAAAAAPS0kKChVRRgB6HfDxkZtFr-OhF1"
            onloadCallback={setRecaptchaReference}
            verifyCallback={setVerifyCallback}
          />
        )}
        <Button
          submit
          className="video-signup-input video-signup-CTA"
          size="large"
          disabled={
            !passUtils.meetsAllRequirements(password, passUtils.getDefaultConfig()) ||
            !email ||
            (isGdprConsentRequired && !isGdprConsentGranted) ||
            (!verifyCallback && !hideRecaptcha)
          }
          loading={createOrgLoading || checkEmailIsSSOEnabledPending || splitLoading}
        >
          Sign up
        </Button>
        {isGdprConsentRequired && (
          <Consent
            checked={isGdprConsentGranted}
            onChange={() => setGdprConsentGranted(!isGdprConsentGranted)}
          />
        )}
        {!disabledEmail && !isGdprConsentRequired && (
          <Fragment>
            <div className="touchless-start-oauth-border">
              <p>or</p>
            </div>
            <div className="video-signup-oauth-container">
              <GoogleAuth onProcessingGoogleCode={onProcessingGoogleCode} onProcessingExternalGoogleCode={onProcessingExternalGoogleCode}/>
              <MicrosoftAuth onProcessingMicrosoftCode={onProcessingMicrosoftCode}/>
            </div>
            {oauthError && (
              <p className="touchless-start-button-error">{oauthError}</p>
            )}
          </Fragment>
        )}
      </Div>
      <Div className="video-signup-card-footer">
        <span>Already have an account?</span>
        <A href={loginUrl}>Sign in</A>
      </Div>
    </Form>
  )
}

export default SignupCard



// WEBPACK FOOTER //
// ./src/layouts/SignupCard/video-signup-component.js